import _ from 'lodash';
import type { ConditionProperty } from '@/tools/conditionWithProperties/conditionWithProperties.types';
import type { ValueWithUnitsItem } from '@/trend/ValueWithUnits.atom';

export const getUpdatedConditionProperty = (
  currentProperty: ConditionProperty | undefined,
  value: Partial<ConditionProperty>,
): ConditionProperty => {
  const stringSignal = value.stringSignal;
  const propertyName =
    stringSignal && typeof stringSignal === 'object' && 'name' in stringSignal && stringSignal.name
      ? stringSignal.name
      : value.propertyName;

  return {
    stringSignal: currentProperty?.stringSignal ?? '',
    propertyName: currentProperty?.propertyName ?? '',
    ...value,
    ...(propertyName === undefined ? {} : { propertyName }),
  };
};

export const validatePropertyName = (propertyName: string, properties: ConditionProperty[]) =>
  _.chain(properties)
    .pickBy({ propertyName: _.trim(propertyName) })
    .values()
    .value().length > 1;

export const validateNameNoDecimals = (propertyName: string) => _.includes(propertyName as string, '.');

export const formatMaxCapsuleDuration = (maxCapsuleDuration: ValueWithUnitsItem) =>
  `${maxCapsuleDuration.value}${maxCapsuleDuration.units}`;

export const generateParameters = (properties: ConditionProperty[]) =>
  _.reduce(
    properties,
    (prev, curr, index) => ({
      ...prev,
      [`property${index + 1}Signal`]: _.get(curr, 'stringSignal.id'),
    }),
    {},
  );

export const generateFormula = (properties: ConditionProperty[]) => {
  const prefixArr = _.map(properties, (property, index) => {
    const toCondition = `$property${index + 1}Signal.toCondition("${property.propertyName}")`;

    return `$property${index + 1}Condition = ${toCondition}\n`;
  });
  const conditionVariables = properties.map((_property, index) => `$property${index + 1}Condition`).join(', ');
  const combineWith = `combineWith(${conditionVariables}).fragment(keepProperties())`;

  return `${prefixArr.join('')}${combineWith}`;
};

export const modifiedSelectedProperty = (
  propertyIndex: number,
  properties: ConditionProperty[],
  initialPropertyName?: string,
): string | undefined | null => {
  const propertyName = properties[propertyIndex]?.propertyName ?? (propertyIndex > -1 ? null : undefined);

  return propertyName !== initialPropertyName ? propertyName : undefined;
};
